import { connect } from 'react-redux';
import { StatAction, UserAction } from '../../actions';
import { bindActionCreators } from 'redux';
import User from './User';

const mapStateToProps = (state) => {
	return {
		stat: state.stat,
		user: state.user,
		coin: state.coin
	};
};

const mapDispatchToProps = (dispatch) => ({
	statAction: bindActionCreators(StatAction, dispatch),
	userAction: bindActionCreators(UserAction, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(User);
